import styled from "styled-components";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

export const Container = styled(Row)`
  font-family: "Raleway";
  margin-top: 20px;
  border-top: 1px solid #dfe1e4;
  clear: both;
  margin-left: 0;
  margin-right: 0;
`;

export const Button = styled(Link)`
  color: #fff;
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: none;
  background-color: #8290a2;
  border-color: #8290a2;
  padding: 6px 0;
  text-align: center;
  min-width: 100px;
  float: right;
  border-radius: 7px;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: #fff;
    background-color: #39b54a;
    border-color: #39b54a;
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    text-decoration: none;
    transition: all 0.2s ease-in-out;
  }
`;

export const AppliedBadge = styled.span`
  background-color: #39b54a;
  border-color: #39b54a;
  font-size: 1.2rem;
  color: white;
  padding: 0.2rem 0.5rem;
  border-radius: 0.4rem;
  position: relative;
  top: -2px;
  margin-left: 1rem;

  &::after {
    font-family: "FontAwesome";
    content: "\f058";
    padding-left: 0.5rem;
  }
`;

export const StyledCol = styled(Col)`
  @media screen and (max-width: 414px) {
    width: 100%;
  }
`;

export const JobTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  a {
    color: #337ab7;
    &:hover {
      text-decoration: none;
    }
  }
`;

export const JobDetails = styled.ul`
  list-style: none;
  padding: 0;
`;

export const JobDetail = styled.li`
  padding-right: 10px;
  display: inline;
  i {
    padding-right: 0.3em;
  }
`;
